export const getSpendingFiles = (spending) => {
    const files = spending?.spending_files;
    return Array.isArray(files) ? files : [];
};

export const isPdfFile = (file) => file?.filetype === "application/pdf";

export const isImageFile = (file) => file?.filetype?.startsWith("image/");

export const getAttachmentPreviewKey = (file, index) => `${file?.filename || "missing"}-${index}`;

export const isInvalidPreviewBlobResponse = (blob, contentType = "") => {
    const normalizedContentType = `${contentType}`.toLowerCase();
    const isHtmlResponse = normalizedContentType.includes("text/html");
    const isJsonErrorResponse = normalizedContentType.includes("application/json");
    const isEmptyResponse = !blob || blob.size === 0;
    return isHtmlResponse || isJsonErrorResponse || isEmptyResponse;
};
